// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/316770fa4a6dd248fabd.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"7a07a3a7fb627f15b339","127":"7d0e0f283c0203837d29","128":"8890edfbc1bc2533e26d"}[chunkId] + ".chunk.js";
};